import {
  type GetVariables,
  type TrayQuery,
  callConnector,
  createUserAuthentication,
  getAuthentications,
  getSolutionInstance,
  getSolutionInstances,
  getSolutions,
  getUsers,
  getViewerDetails,
  removeAuthentication,
  updateSolutionInstance,
  updateUserAuthentication,
} from './queries';

export function queryPayload<Variables = unknown>(
  query: TrayQuery<Variables>,
  variables: Variables,
): string {
  return query.formatQuery(variables);
}

export const getTrayPayload = (
  dataType: string,
  variables: GetVariables<TrayQuery<unknown>> = {},
): string => {
  const queryMap = {
    authentications: getAuthentications,
    solutionInstance: getSolutionInstance,
    users: getUsers,
    solutions: getSolutions,
    solutionInstances: getSolutionInstances,
    viewerDetails: getViewerDetails,
    updateSolutionInstance: updateSolutionInstance,
    createUserAuthentication: createUserAuthentication,
    removeAuthentication: removeAuthentication,
    updateUserAuthentication: updateUserAuthentication,
    callConnector: callConnector,
  };
  const query = queryMap[dataType as keyof typeof queryMap];
  if (!query) {
    throw new Error(`No query function found for data type: ${dataType}`);
  }
  return queryPayload(query, variables);
};
